export default {
    getTeacherInfo: {
        url: '/base/baseteacher/detail',
        method: 'get'
    },
    getTeacherCourse: {
        url: '/base/baseteacher/getTeacherRelateCourse',
        method: 'get'
    },
    getTeacherPublishCourse: {
        url: '/crm/crmpublish/getTeacherPublishLesson',
        method: 'get'
    },
    getTeacherCourseStatistics: {
        url: '/crm/studentsignup/getTeacherPublishStatistics',
        method: 'get'
    },
}
